import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { CacheKey } from 'app/helpers/app-constants';
import { map, Observable } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state): Observable<boolean | UrlTree> => {
    const router: Router = inject(Router);
    //  Inject the authService once so we can use multiple methods from it
    const authService: AuthService = inject(AuthService);

    // Check the authentication status
    return authService.check().pipe(
        map((authenticated) => {
            //  If not authenticated, redirect to sign-in
            if (!authenticated) {
                const skipRedirect = ['/sign-out', '/', '/sign-up'].some((url) => state.url === url || state.url.startsWith(url));
                const queryParams = skipRedirect ? '' : `?redirectURL=${encodeURIComponent(state.url)}`;
                return router.parseUrl(`sign-in${queryParams}`);
            }

            // handle external auth edge-cases
            const isExternalAuth = !!localStorage.getItem(CacheKey.externalAuth);
            if (isExternalAuth && (state.url === '/' || state.url === '')) {
                return router.parseUrl('sign-in');
            }

            // Allow the access
            return true;
        })
    );
};
